import { SubscriptionManagementProvider } from '~/context/SubscriptionManagement';
import type { Community, CurrentCommunityMember } from '~/interfaces/community';
import type { Publication } from '~/interfaces/publication';
import type { Site } from '~/interfaces/site';
import type { Subscription } from '~/interfaces/subscriptions';

import PageInner from './PageInner';

interface Props {
  site: Site;
  publication: Publication;
  subscription: Subscription;
  subscriberId: string;
  isLoggedIn: boolean;
  community?: Community | null;
  currentCommunityMember?: CurrentCommunityMember | null;
}

const Page = (props: Props) => {
  return (
    <SubscriptionManagementProvider
      subscription={props.subscription}
      publication={props.publication}
      subscriberId={props.subscriberId}
      isLoggedIn={props.isLoggedIn}
    >
      <PageInner {...props} />
    </SubscriptionManagementProvider>
  );
};

export default Page;
